<template>
    <div class="search-header">
        <div class="input">
            <svg-icon class="icon" icon-class="search2"></svg-icon>
            <sd-input type="search" :placeholder="placeholder || 'Search for brand info'" v-model="value" @enter="$emit('enter')" :clear="clear"></sd-input>
        </div>
        <div class="cancel" @click="$utils.back()">{{$t('text.cancel')}}</div>
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "search-header",
    props: {
        searchkey: String | Number,
        placeholder: String,
        clear: false
    },
    data() {
        return {
            value: this.searchkey || ""
        }
    },
    watch: {
        searchkey(val) {
            this.value = val;
        },

        value(val) {
            this.$emit('update:searchkey', val);
        }
    }
}
</script>

<style lang="scss" scoped>
.search-header {
    height: 36px;
    padding: 4px 12px;
    display: flex;
    align-items: center;

    .input {
        width: 288px;
        display: flex;
        height: 100%;
        border-radius: 18px;
        background-color: #F4F5F8;
        align-items: center;

        .search2 {
            width: 20px;
            margin-left: 10px;
        }

        .project-input {
            height: 36px;
            border: none;
            line-height: 36px;
            margin-bottom: 0;

            /deep/ {
                input {
                    margin: 0 8px;
                    background-color: transparent;
                }
            }
        }
    }

    .cancel {
        color: #787D85;
        margin-left: 12px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/common/searchHeader.vue